/**
 * This plugin customizes Supabase auth's redirect behavior for public pages
 */
export default defineNuxtPlugin((nuxtApp) => {
  // Check if we're redirecting to login
  nuxtApp.hook('page:start', async () => {
    const route = useRoute()
    const fromPath = route.redirectedFrom?.path || ''
    
    // If we detect a login redirect from the home page, intercept it
    if (route.path === '/login' && (fromPath === '/' || !fromPath)) {
      console.log('[SUPABASE-REDIRECT] Detected potential auth redirect to login from home page')
      
      // Get current page meta
      const pageRouteMeta = route.meta || {}
      const previousRouteMeta = route.redirectedFrom?.meta || {}
      
      // Check if the previous page had auth:false
      if (previousRouteMeta.auth === false || route.name === 'index') {
        console.log('[SUPABASE-REDIRECT] Previous page was marked as public, redirecting back')
        
        // Navigate back to the home page to prevent the login redirect
        const router = useRouter()
        router.replace('/')
        return
      }
    }
  })
}) 